import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Modal, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import {
  getInterestslIST,
  addInterests,
  editInterests,
  deleteInterests,
} from "../../common/api";
import { ShowToast } from "../../common/function";
import { Sentry, Spinner } from "react-activity";

export default function InterestsPage() {
  const [searchText, setSearchText] = useState("");
  const [interestsList, setInterestsList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [interestName, setInterestName] = useState("");
  const [interestId, setInterestId] = useState("");
  const [errors, setErrors] = useState({});

  const handleCloseDelete = () => {
    setShowDeleteModal(false);
    setInterestId("");
  };
  const handleCloseAdd = () => {
    setInterestName("");
    setErrors({});
    setShowAddModal(false);
  };
  const handleCloseEdit = () => {
    setInterestId("");
    setInterestName("");
    setErrors({});
    setShowEditModal(false);
  };

  const getInterestsList = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const response = await getInterestslIST(token, {});
    if (response.success) {
      setInterestsList(response.body);
      setLoading(false);
    } else {
      ShowToast(0, response.message);
    }
  };

  useEffect(() => {
    getInterestsList();
  }, []);

  const handleAddInterest = async () => {
    if (!interestName.trim()) {
      setErrors({ interestName: "Please enter interest name" });
      return;
    }
    const token = localStorage.getItem("token");
    setIsLoading(true);
    const res = await addInterests(token, {
      interset_name: interestName.trim(),
    });
    setIsLoading(false);
    if (res.success) {
      ShowToast(1, "Interest added successfully");
      getInterestsList();
      handleCloseAdd();
    } else {
      ShowToast(0, res.message || "Failed to add interest");
    }
  };

  const handleEditInterest = async () => {
    if (!interestName.trim()) {
      setErrors({ interestName: "Please enter interest name" });
      return;
    }
    setIsLoading(true)
    const token = localStorage.getItem("token");
    const res = await editInterests(token, {
      interset_id: interestId,
      interset_name: interestName.trim(),
    });
    setIsLoading(false)
    if (res.success) {
      ShowToast(1, "Interest updated successfully");
      getInterestsList();
      handleCloseEdit();
    } else {
      ShowToast(0, res.message || "Failed to update interest");
    }
  };

  const handleDeleteInterest = async () => {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    const res = await deleteInterests(token, { interset_id: interestId });
    setIsLoading(false)
    if (res.success) {
      ShowToast(1, "Interest deleted successfully");
      getInterestsList();
      handleCloseDelete();
    } else {
      ShowToast(0, res.message || "Failed to delete interest");
    }
  };

  const handleOpenEdit = (row) => {
    setInterestId(row._id);
    setInterestName(row.interset_name);
    setErrors({});
    setShowEditModal(true);
  };

  const handleOpenDelete = (row) => {
    setInterestId(row._id);
    setShowDeleteModal(true);
  };

  const columns = [
    {
      name: "Sr. No.",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row.interset_name,
      sortable: true,
      cell: (row) => <>{row.interset_name || "N/A"}</>,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btnedit" onClick={() => handleOpenEdit(row)}>
            <Icon icon="tabler:pencil" />
          </Link>
          <Link className="btndelete" onClick={() => handleOpenDelete(row)}>
            <Icon icon="tabler:trash" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData =
    interestsList?.length > 0
      ? interestsList.filter((item) =>
          JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
        )
      : [];

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between py-3">
              <h5>Interests</h5>
              <Button className="btnadd" onClick={() => setShowAddModal(true)}>
                <Icon icon="tabler:plus" /> Add Interest
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? (
                <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Add Interest Modal */}
      <Modal
        centered
        show={showAddModal}
        onHide={handleCloseAdd}
        className="changeLocationModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Interest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-4 form-group">
              <Form.Label>Interest Name</Form.Label>
              <Form.Control
                type="text"
                value={interestName}
                onChange={(e) => {
                  setInterestName(e.target.value);
                  setErrors((prev) => ({ ...prev, interestName: "" }));
                }}
                placeholder="Enter Interest Name"
              />
              {errors.interestName && (
                <p className="text-danger mt-1">{errors.interestName}</p>
              )}
            </Form.Group>
            <Button
              className="px-4 min_width110"
              variant="primary"
              onClick={handleAddInterest}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner animation="border" variant="primary" size={15} />
              ) : (
                "Add"
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Interest Modal */}
      <Modal
        centered
        show={showEditModal}
        onHide={handleCloseEdit}
        className="changeLocationModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Interest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-4 form-group">
              <Form.Label>Interest Name</Form.Label>
              <Form.Control
                type="text"
                value={interestName}
                onChange={(e) => {
                  setInterestName(e.target.value);
                  setErrors((prev) => ({ ...prev, interestName: "" }));
                }}
                placeholder="Enter Interest Name"
              />
              {errors.interestName && (
                <p className="text-danger mt-1">{errors.interestName}</p>
              )}
            </Form.Group>
            <Button
              className="px-4 min_width110"
              variant="primary"
              onClick={handleEditInterest}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner animation="border" variant="primary" size={15} />
              ) : (
                "Update"
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        className="modal_Delete"
        show={showDeleteModal}
        onHide={handleCloseDelete}
        centered
      >
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleCloseDelete}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={handleDeleteInterest}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner animation="border" variant="success" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
